import styled from '@emotion/styled';
import CaretV2Icon from '../SvgIcons/CaretV2';
import Checkmark from '../SvgIcons/Checkmark';
import { FONT, SPACING } from '../../styles/emotion';
import COLORS from '../../styles/emotion/colors3';

export const ChipContainer = styled.button<{
  selected?: boolean;
  active?: boolean;
  twoLines?: boolean;
  width?: string;
  withCaret?: boolean;
}>`
  padding: 12px 16px;
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  font-size: ${FONT.FONT_SIZE_SMALL};
  line-height: 16px;
  color: ${COLORS.BLACK_100};
  background-color: ${COLORS.WHITE_100};
  border: 1px solid ${COLORS.BLACK_030};
  border-radius: 16px;
  cursor: pointer;
  ${({ width }) => width && `width: ${width}`};
  &:hover {
    background-color: ${COLORS.BLACK_005};
    border-color: ${COLORS.BLACK_050};
  }

  &:focus-visible {
    outline: 5px auto Highlight;
    outline: 5px auto -webkit-focus-ring-color;
  }

  &:disabled {
    background-color: ${COLORS.WHITE_100};
    border-color: ${COLORS.BLACK_030};
    color: ${COLORS.BLACK_030};
  }

  ${({ selected, active }) =>
    (selected || active) &&
    `
    color: ${COLORS.BLACK_100};
    border-color: ${COLORS.BLACK_100};
    background-color: ${COLORS.BLACK_005};
    &:hover {
      color: ${COLORS.BLACK_100};
      border-color: ${COLORS.BLACK_100};
    }
    `};

  ${({ twoLines }) =>
    twoLines &&
    `
    height: 62px;
    line-height: ${SPACING.MD};
    padding-top: 0;
    padding-bottom: 0;
    margin-right: ${SPACING.SM};
  `};

  ${({ withCaret }) =>
    withCaret &&
    `
    display: flex;
    align-items: center;
  `};
`;

export const StyledCaret = styled(CaretV2Icon)<{ selected?: boolean }>`
  margin-left: ${SPACING.XS};
  width: auto !important;
  max-width: 14px;
  ${({ selected }) =>
    selected &&
    `
    transform: rotate(180deg);
    padding-top: 2px;
    `};
  transition: transform 0.2s ease;
`;

export const StyledCheckmark = styled(Checkmark)`
  margin-right: 4px;
  height: 12px;
  width: 12px;
`;
